import { Component, Input } from '@angular/core';
import { DocumentSource } from '../shared/pod-validation.model';

@Component({
  selector: 'app-pods-validation-document-source',
  templateUrl: './pods-validation-document-source.component.html',
  styleUrls: ['./pods-validation-document-source.component.scss']
})
export class PodsValidationDocumentSourceComponent {

  @Input()
  public source: DocumentSource;

  public sourceToLabel(source: DocumentSource) {
    switch (source) {
      case DocumentSource.CMAWEB_API: return 'CMAWEB';
      case DocumentSource.CMA_API: return 'CMA';
      case DocumentSource.CARRIER_API: return 'API';
    }
  }
}
